export default "__VITE_ASSET__DGniBuch__"